import { render } from "./PatientsDatatableTDDoctorName.vue?vue&type=template&id=7e52bc22&scoped=true"
import script from "./PatientsDatatableTDDoctorName.vue?vue&type=script&lang=js"
export * from "./PatientsDatatableTDDoctorName.vue?vue&type=script&lang=js"

import "./PatientsDatatableTDDoctorName.vue?vue&type=style&index=0&id=7e52bc22&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e52bc22"]])

export default __exports__